import Grid from "@mui/material/Grid";

import { LoadingOrValue } from "@covertree/ui";
import DisplayPropertiesCard from "@covertree/ui/content/DisplayPropertiesCard";
import { PolicyDetailsContentProps } from "../../../types";

export function OrganizationDetails({
  policy,
  loading,
}: PolicyDetailsContentProps) {
  const { orgName, orgType, describeOrgType } = policy.policyholder;

  return (
    <Grid item xs={12}>
      <DisplayPropertiesCard
        properties={[
          {
            label: "Organization name",
            value: (
              <LoadingOrValue
                loading={!policy && loading}
                value={orgName}
                height={24}
                width={121}
              />
            ),
            showAsTypography: true,
            gridSize: 6,
          },
          {
            label: "Organization type",
            value: (
              <LoadingOrValue
                loading={!policy && loading}
                value={orgType ?? describeOrgType}
                height={24}
                width={121}
              />
            ),
            showAsTypography: true,
            gridSize: 6,
          },
        ]}
      />
    </Grid>
  );
}
